// extracted by mini-css-extract-plugin
module.exports = {"iconAndTextGrouping":"UiChip_iconAndTextGrouping__68pDm","defaultIconStyle":"UiChip_defaultIconStyle__1yvLu"};